import { FC } from 'react';

import { BUSINESS_TYPE } from '@/api/types';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/Form';
import Select from '@/components/ui/Select/Select';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

interface Props {
  name?: string;
  isComplementary?: boolean;
}

export const BUSINESS_TYPE_NAME = 'business_type';
export const BUSINESS_TYPE_NAME_COMPLEMENTARY = 'business_type_complementary';

export const SelectBusinessType: FC<Props> = ({
  name,
  isComplementary = false,
}) => {
  const { i18n } = useLingui();
  const { control } = useFormContext();

  const fieldName =
    name ??
    (isComplementary ? BUSINESS_TYPE_NAME_COMPLEMENTARY : BUSINESS_TYPE_NAME);

  return (
    <FormField
      control={control}
      name={fieldName}
      rules={{
        required: {
          value: true,
          message: i18n.t('Uzupełnij to pole, aby przejść dalej'),
        },
      }}
      render={({ field, fieldState }) => (
        <FormItem>
          <FormLabel>{i18n.t('Wskaż rodzaj działalności?')}</FormLabel>
          <FormControl>
            <Select
              {...field}
              placeholder={i18n.t('Rodzaj działalności gospodarczej')}
              success={fieldState.isDirty && !fieldState.error && field.value}
              options={[
                {
                  label: i18n.t('Jednoosobowa działalność gospodarcza'),
                  value: BUSINESS_TYPE.JDG,
                },
                {
                  label: i18n.t('Spółka z ograniczoną odpowiedzialnością'),
                  value: BUSINESS_TYPE.ZOO,
                },
                {
                  label: i18n.t('Spółka cywilna'),
                  value: BUSINESS_TYPE.SC,
                },
                {
                  label: i18n.t('Spółka jawna'),
                  value: BUSINESS_TYPE.SJ,
                },
                {
                  label: i18n.t('Spółka akcyjna'),
                  value: BUSINESS_TYPE.SA,
                },
                {
                  label: i18n.t('Spółka komandytowa'),
                  value: BUSINESS_TYPE.SK,
                },
                {
                  label: i18n.t('Spółka komandytowo-akcyjna'),
                  value: BUSINESS_TYPE.SKA,
                },
              ]}
              data-testid="multi-select-business-type"
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
